export default "__VITE_ASSET__f4609ada__"